
import {Component, Vue} from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import {RequestPaging} from "@/utils/util";
import {apiNewsLists, apiNewsDel} from '@/api/shop'

@Component({
  components: {
    lsPagination
  }
})
export default class NewsList extends Vue {
  pager: RequestPaging = new RequestPaging();
  searchObj = {};

  async getLists(): Promise<void> {
    this.pager.request({
      callback: apiNewsLists,
      params: {...this.searchObj, type: 2} // type=2表示资讯
    });
  }

  async onDelete(row: any): Promise<void> {
    await apiNewsDel({id: row.id});
    this.getLists();
  }

  created() {
    this.getLists();
  }
}
